import React from "react";

export const Articles: React.FC = () => {
  return (
    <div id="consider" className="articles-section">
      <img 
        src="img/img4.webp" 
        alt="Endocomunidad" 
        className="articles-background"
      />
      <div className="articles-overlay"></div>
      <div className="articles-content">
        <div className="articles-grid">
          {/* Left Column - No somos médicos */}
          <div className="articles-column">
            <img 
              src="img/stethoscope.svg" 
              alt="Stethoscope" 
              className="articles-icon"
            />
            <h2 className="articles-title">NO SOMOS MÉDICOS</h2>
            <p className="articles-text">
              TODA LA INFORMACIÓN QUE ENCUENTRES AQUÍ TENDRÁ DETALLADA SU FUENTE, 
              PERO BAJO NINGÚN PUNTO SUSTITUYE EL CONSEJO DE UN MÉDICO
            </p>
          </div>

          {/* Right Column - No tenemos sesgo */}
          <div className="articles-column">
            <img 
              src="img/dollar.svg" 
              alt="Dollar sign" 
              className="articles-icon"
            />
            <h2 className="articles-title">NO TENEMOS SESGO</h2>
            <p className="articles-text">
              HEMOS RECIBIDO APOYO DE EMPRESAS ASOCIADAS A LA SALUD, 
              PERO LA INFORMACIÓN SIEMPRE SERÁ OBJETIVA.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

